const HASH_ROUTING_HOSTS = new Set(['mail.qixit.com', 'stmail.qixit.com']);

const AUTH_ENTRY_PATHS = ['/login', '/register', '/verify-email', '/reset-password'];

export function usesHashRouting(): boolean {
  if (typeof window === 'undefined') return false;
  return HASH_ROUTING_HOSTS.has(window.location.hostname.toLowerCase());
}

/**
 * Resolves the in-app route. On HashRouter hosts, pathname may stay `/login`
 * while the real route is `#/messages` — prefer the hash in that case.
 */
export function getEffectiveAppPath(): string {
  if (typeof window === 'undefined') return '/';

  if (usesHashRouting()) {
    const rawHash = (window.location.hash || '').replace(/^#/, '');
    const hashPath = (rawHash.split('?')[0] || '').toLowerCase();
    if (hashPath && hashPath !== '/') {
      return hashPath.startsWith('/') ? hashPath : `/${hashPath}`;
    }
  }

  return (window.location.pathname || '/').toLowerCase();
}

function pathMatchesAuthEntry(path: string): boolean {
  return AUTH_ENTRY_PATHS.some(
    (authPath) => path === authPath || path.startsWith(`${authPath}/`)
  );
}

export function isAuthEntryRoute(): boolean {
  if (typeof window === 'undefined') return false;
  return pathMatchesAuthEntry(getEffectiveAppPath());
}

export function getLoginPath(): string {
  return usesHashRouting() ? '/#/login' : '/login';
}

export function redirectToLogin(): void {
  if (typeof window === 'undefined') return;
  window.location.replace(getLoginPath());
}

export function isPublicAuthRequest(url?: string): boolean {
  if (!url) return false;
  const normalized = url.toLowerCase();
  return (
    normalized.includes('/api/auth/login')
    || normalized.includes('/api/auth/refresh')
    || normalized.includes('/api/auth/logout')
    || normalized.includes('/api/auth/verify-ip')
    || normalized.includes('/api/auth/verifyip')
  );
}
